import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlarmClock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { prApi } from '@/services/prApi';

/** Reminder when posted requisitions are past their required-by date with qty still to order. */
export const PrOverdueBanner = ({ onShowAll, refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => { prApi.overdue().then(setD).catch(() => setD(null)); }, [refreshKey]);
  if (!d?.count) return null;
  const many = d.count > 1;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-rose-200 bg-rose-50 px-4 py-3" data-testid="pr-overdue-banner">
      <AlarmClock className="h-5 w-5 shrink-0 text-rose-600" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-rose-900" data-testid="pr-overdue-count">
          {d.count} requisition{many ? 's are' : ' is'} past the required-by date with qty still to order</p>
        <div className="mt-1 flex flex-wrap gap-1.5">
          {d.prs.slice(0, 5).map((p) => (
            <Link key={p.pr_id} to={`/pr/${p.pr_id}`} className="rounded border border-rose-200 bg-white px-2 py-0.5 text-[11px] text-rose-800 hover:bg-rose-100"
              data-testid={`pr-overdue-chip-${p.pr_id}`}>
              <span className="font-mono">{p.pr_number}</span> · {p.section_name} · {p.days_late}d late</Link>))}
          {d.count > 5 && <span className="px-1 text-[11px] text-rose-700">+{d.count - 5} more</span>}
        </div>
      </div>
      <Button size="sm" variant="outline" className="border-rose-300 bg-white text-rose-700 hover:bg-rose-100" onClick={onShowAll} data-testid="pr-overdue-show-all">
        Show overdue</Button>
    </div>
  );
};

export default PrOverdueBanner;
